var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkmodeOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.20351 9.1853C7.38101 5.64965 8.36516 2.4785 9.26729 0.738017C9.44043 0.409968 9.15794 0.036355 8.78433 0.0819175C4.20986 0.701568 0.710657 4.70195 0.902019 9.48602C0.911132 9.48602 0.911132 9.48602 0.911132 9.49513C1.47611 9.24909 2.08664 9.1124 2.73363 9.1124C4.24631 9.1124 5.63141 9.86874 6.46976 11.0716C7.99154 11.509 9.11238 12.9123 9.11238 14.5799C9.11238 15.965 8.31959 17.1587 7.18053 17.7784C8.07356 18.07 9.03037 18.234 10.0145 18.234C12.8667 18.234 15.4091 16.9218 17.0858 14.8715C17.3227 14.5799 17.1223 14.1516 16.7487 14.1243C14.4796 14.0058 11.026 12.7301 9.20351 9.1853Z",
    fill: "#08A3AC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4675 11.7573H5.30347C4.92075 10.7003 3.91838 9.93481 2.73375 9.93481C1.22108 9.93481 0 11.1559 0 12.6686C0 14.1812 1.22108 15.4023 2.73375 15.4023C3.29873 15.4023 5.00276 15.4023 5.4675 15.4023C6.46988 15.4023 7.29 14.5822 7.29 13.5798C7.29 12.5774 6.46988 11.7573 5.4675 11.7573Z",
    fill: "#08A3AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkmodeOn);
export default __webpack_public_path__ + "static/media/darkmode-on.1ffd7b06a9fa35de48eed5b2f5034f0c.svg";
export { ForwardRef as ReactComponent };